// Characters to choose from at night (the Courtier's, the Gambler's guess). Names only, grouped
// by kind like the script sheet: an icon is easy to spot across the table (RoleIcon), so night
// screens never show one.
import type { RoleCard } from "../protocol";
import { KINDS } from "./Characters";

export function CharacterPicker({
  roleIds,
  roles,
  selected,
  onToggle,
}: {
  roleIds: string[];
  roles: Record<string, RoleCard>;
  selected: string[];
  onToggle: (roleId: string) => void;
}) {
  return (
    <div className="stack" role="group" aria-label="Characters">
      {KINDS.map((k) => {
        const ofKind = roleIds.filter((id) => roles[id]?.role_type === k.type);
        if (ofKind.length === 0) return null;
        return (
          <div key={k.type} className="stack-sm">
            <span className="eyebrow">{k.label}</span>
            <div className="row wrap" style={{ gap: 6 }}>
              {ofKind.map((id) => (
                <button
                  key={id}
                  type="button"
                  className="btn btn-small"
                  aria-pressed={selected.includes(id)}
                  onClick={() => onToggle(id)}
                >
                  {roles[id]?.name ?? id}
                </button>
              ))}
            </div>
          </div>
        );
      })}
    </div>
  );
}
